import { Injectable, OnDestroy } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, Subscription } from 'rxjs';

import { TenantService } from './tenant.service';
import { IUserWaySSOLink, UserWayOrganizationAuthRequestTarget } from '../../../shared/interfaces/userway-integration.interface';
import { CommonUtility } from '../utility/common.utility';

@Injectable({
  providedIn: 'root',
})
export class UserWayNavigationService implements OnDestroy {
  private subscriptions: Subscription;
  constructor(private readonly tenantService: TenantService) {
    this.subscriptions = new Subscription();
  }

  public navigateToUserWayDashboard(onError: (error: HttpErrorResponse) => void): void {
    this.subscriptions.add(
      this.tenantService.generateUserWaySSOLink(UserWayOrganizationAuthRequestTarget.DASHBOARD).subscribe({
        next: this.onGenerateSSOLinkSuccess.bind(this),
        error: onError,
      }),
    );
  }

  public generateUserWaySSOLink(
    target: UserWayOrganizationAuthRequestTarget,
    userwayAccountCode?: string,
  ): Observable<IUserWaySSOLink> {
    return this.tenantService.generateUserWaySSOLink(target, userwayAccountCode);
  }

  private onGenerateSSOLinkSuccess(link: IUserWaySSOLink): void {
    CommonUtility.navigateToExternalUrl(link.ssoLink, true);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
